exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-container[data-v-d8f8c1f8] {\n  padding: 8px;\n  overflow: auto;\n  height: 100%;\n  text-align: left;\n  position: relative;\n}\n.tab-box[data-v-d8f8c1f8] {\n  padding: 16px;\n}\n[data-v-d8f8c1f8] .tabs > ul {\n  margin-left: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8f8c1f8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/DashBoard/Setting/Billing/BillingSetting.vue
// module id = ySx4
// module chunks = 0